import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "../../BaseMixer";
import { IDetailDTO } from "@/store/models/list/detail";
let ListDetailUpsertComponent = /** @class */ (() => {
    var _a;
    let ListDetailUpsertComponent = class ListDetailUpsertComponent extends Mixins(BaseMixer) {
        checkAndSendSave() {
            this.validate("listDetailObserver").then((response) => {
                if (response) {
                    return this.save();
                }
            });
        }
        save() { }
        cancel() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IDetailDTO !== "undefined" && IDetailDTO) === "function" ? _a : Object)
    ], ListDetailUpsertComponent.prototype, "model", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ListDetailUpsertComponent.prototype, "save", null);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ListDetailUpsertComponent.prototype, "cancel", null);
    ListDetailUpsertComponent = __decorate([
        Component
    ], ListDetailUpsertComponent);
    return ListDetailUpsertComponent;
})();
export default ListDetailUpsertComponent;
